import React, { useContext, useState, useEffect } from "react";
import style from "src/Assets/css/home/Homepagerightsidebar.module.css";
import UpdateTagPostDataModal from "../../../Modules/Reusuablecomponents/UpdateTagPostDataModal";
import Contributors from "./Contributors";
import styles from "src/Assets/css/home/post.module.css";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import InviteFollowers from "./InviteFollowers";
import AvatarBadge from "src/Components/AvatarBadge";
import arrowSvg from "src/Assets/images/arrowSvg.svg";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import inviteToBeImapctFullMemberImage from "src/Assets/images/impactful_nominate_img_new.png";
import { useSelector } from "react-redux";
import NominateUser from "src/Modules/Moderator/ReusableModeratorComponents/NominateUser";

function RightSideBar(props) {
  const {
    contributorsData,
    trendingTags = [],
    trendingAsks = [],
    setShowData,
    showModal,
    modalType,
    // filterType,
    filterPosts,
    changeValue,
    onUpdateSelection,
    hideUpdateModal,
    fetchFeedData,
    showData,
    fetchContributors,
    pageType,
    isDisabled,
    selectedCommunity,
    isActionDisabled,
    onActionSuccess
  } = props;
  // console.log('trendingTags RightSideBar', trendingTags);
  // const contributorsData = useSelector(
  //   (state) => state.feedReducer.contributorsData
  // );
  // const isLoaded = useSelector((state) => state.feedReducer.isLoaded);

  // const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const communityFollowNames = userDetails?.userData?.communityFollowNames || [];
  const currentTenantId =
    selectedCommunity?.tenantId ||
    userDetails?.userData?.viewActivityUserTenantInfo?.tenantId;
  const hasFollowedCommunity = communityFollowNames.some(
    (c) =>
      String(c.id) === String(currentTenantId) ||
      String(c.tenantID) === String(currentTenantId) ||
      String(c.tenantId) === String(currentTenantId)
  );
  const isNominateDisabled =
    (isDisabled || isActionDisabled) && !hasFollowedCommunity;
  // const [modalShow, setModalShow] = React.useState(false);
  // const [isModalType, setModalType] = React.useState(null);
  const [contributorBio, setContributorBio] = React.useState("");
  const [showBio, setShowBio] = React.useState(false);
  const [distFromTop, setDistFromTop] = React.useState("0px");
  const [pointerLeft, setPointerLeft] = React.useState("24px");
  const hideTimerRef = React.useRef(null);
  const [showInviteModal, setShowInviteModal] = React.useState(false);
  const [messageId, setMessageId] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [selectedTagId, setSelectedTagId] = useState(null);
  const commonModalContext = useContext(CommonModalContext);

  const onUpdate = (modalType) => {
    if (isDisabled) return;
    onUpdateSelection(modalType);
  };

  const moreTrendingTags = () => {
    setShowData("tag");
    setSelectedTagId(null);
  };

  const moreTrendingAsks = () => {
    setShowData("ask");
  };

  const TagDetail = (tagId) => {
    const tId = selectedCommunity?.tenantId ?? "";
    commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
      isTrendingTag: true,
      tenantId: tId,
      tagId,
      onActionSuccess,
    });

    // Toggle the selected tag
    // if (selectedTagId === tagId) {
    //   // If it's already selected (blue), reset the color to black by setting id to null
    //   setSelectedTagId(null);
    //   setShowData("feed");
    // } else {
    //   // If it's black (unselected) or different, set the selected tag id and change color
    //   setSelectedTagId(tagId);
    //   // Call the function when changing to blue
    //   fetchSelectedTagDetails(tagId);
    //   setShowData("singleTrendingTag");
    // }

    // setSelectedTagId(tagId);
    // fetchSelectedTagDetails(tagId);
    // setShowData("singleTrendingTag");
    // dispatch(TagDisplay.fecthDisplayData(tagValue));
  };

  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  const handleClickEvent = (userid, showBio, targetEl) => {
    if (!showBio || !targetEl) {
      scheduleHide();
      return;
    }

    cancelHide();

    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("skopic:closeHoverCards", {
          detail: { cardId: "rightSidebarContributors" },
        }),
      );
    }

    const data = contributorsData?.contribut?.find((d) => d.id === userid);
    setContributorBio(data);
    setShowBio(true);

    const rect = targetEl.getBoundingClientRect();
    const sidebarEl = document.querySelector('[class*="rightSidebar"]');
    const sidebarRect = sidebarEl?.getBoundingClientRect();

    const top = rect.bottom - (sidebarRect?.top ?? 0) + 4;
    setDistFromTop(`${top}px`);

    // horizontal center of avatar relative to bio card's left edge
    const bioCardLeft =
      (sidebarRect?.left ?? 0) + (sidebarRect?.width ?? 0) * 0.1; // matches `left: 10%`
    const avatarCenter = rect.left + rect.width / 2;
    const pointer = avatarCenter - bioCardLeft - 8; // 8 = half of pointer width
    setPointerLeft(`${Math.max(12, pointer)}px`);
  };

  const cancelHide = () => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }
  };

  const scheduleHide = () => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
    }
    hideTimerRef.current = setTimeout(() => {
      setShowBio(false);
    }, 400); // 400ms grace period to move smoothly from image/name to card
  };

  const showInviteModalOnPrivateTagPost = (messageId, tenantId) => {
    console.log(`messageId for success:`, messageId);
    setShowInviteModal(true);
    setMessageId(messageId);
    setTenantId(tenantId);
  };

  const onHideInviteModal = () => {
    setShowInviteModal(false);
    setMessageId("");
    setTenantId("");
  };

  useEffect(() => {
    const handleCloseOthers = (e) => {
      if (e?.detail?.cardId !== "rightSidebarContributors") {
        cancelHide();
        setShowBio(false);
      }
    };
    window.addEventListener("skopic:closeHoverCards", handleCloseOthers);
    return () => {
      window.removeEventListener("skopic:closeHoverCards", handleCloseOthers);
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }
    };
  }, []);

  return (
    <React.Fragment>
      <div className={style.rightSidebar} style={{ position: "relative" }}>
        {/* <span className={style.contributertick}>
          <IoIosCheckmarkCircleOutline />
          <div style={{ marginLeft: "4px" }}>
            Contributors
          </div>
        </span> */}

        <div>
          <Contributors
            handleClickEvent={handleClickEvent}
            contributorsData={contributorsData}
            pageType={pageType}
          />
        </div>
        {showBio && (
          <div
            className={style.profilehover}
            style={{
              top: distFromTop,
              zIndex: 1500,
              "--pointer-left": pointerLeft,
              width: "300px"
            }}
            onMouseEnter={cancelHide}
            onMouseLeave={scheduleHide}
          >
            <div className={feedstyles.profilehoverimageandcount}>
              <div style={{ flexShrink: 0 }}>
                <AvatarBadge
                  src={
                    contributorBio?.uImage
                      ? `${profileImagePath}${contributorBio.uImage}`
                      : process.env.REACT_APP_DUMMY_PROFILE_IMAGE // fallback: use env dummy profile image
                  }
                  className={styles.avatar}
                  isPrimaryModerator={String(contributorBio.isPM) === "1"}
                  isModerator={
                    String(contributorBio.isModerator) === "1" &&
                    String(contributorBio.isPM) === "0"
                  }
                />
              </div>
              <div style={{ marginLeft: "10px", flex: 1, minWidth: 0 }}>
                <span
                  className={feedstyles.profilename}
                  style={{
                    display: "inline",
                    wordBreak: "break-all",
                  }}
                >
                  {contributorBio?.displayName}
                  {contributorBio?.isImpactableMember === "yes" && (
                    <img
                      src={alreadyImpactfulMemberImg}
                      alt="Impactful Member"
                      title="Impactful Member"
                      style={{
                        width: "18px",
                        height: "18px",
                        objectFit: "contain",
                        verticalAlign: "middle",
                        marginLeft: "5px",
                      }}
                    />
                  )}
                </span>
                <p className={feedstyles.profilecount}>
                  {/* ASK {contributorBio?.askcount} |  */}
                  SAYs {contributorBio?.say} | UPDATEs {contributorBio?.iUpdate}{" "}
                  | Answers {contributorBio?.answer}
                </p>
              </div>
              {contributorBio?.id !== userDetails?.userData?.User_ID && (
                <div style={{ flexShrink: 0, marginLeft: "8px" }}>
                  <NominateUser
                    result={contributorBio}
                    contributor={true}
                    disabled={isNominateDisabled}
                    onActionSuccess={onActionSuccess}
                    onModalOpen={() => {
                      cancelHide();
                    }}
                    onModalClose={() => {
                      cancelHide();
                      setShowBio(false);
                    }}
                  >
                    <button
                      type="button"
                      style={{
                        padding: 0,
                        margin: 0,
                        border: "none",
                        background: "transparent",
                        cursor: isNominateDisabled ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        outline: "none",
                      }}
                    >
                      <img
                        src={inviteToBeImapctFullMemberImage}
                        alt="Invite"
                        title={isNominateDisabled ? "Follow community to nominate" : "Nominate as Impactful Member"}
                        style={{
                          width: "23px",
                          height: "23px",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </button>
                  </NominateUser>
                </div>
              )}
            </div>
            <p style={{ margin: 0 }}>{contributorBio?.shortBio}</p>
          </div>
        )}

        {/* <div id="demo" className={`carousel slide ${style.Contributers}`} data-ride="carousel" data-interval="false">

                    <div className="container carousel-inner">
                        <div className="carousel-item active">
                            {
                                (isLoaded)
                                    ?
                                    (contributorsData && Object.keys(contributorsData).length !== 0)
                                        ?
                                        contributorsData.contribut.slice(0,6).map((result) => (
                                            <div className={`row ${style.avatarrow}`}>
                                                <Avatar className={style.contributersavatar} src={`${profileImagePath}${result.uImage}`}></Avatar>
                                            </div>
                                        ))
                                        :
                                        <div>
                                            <p>There is no Contributors</p>

                                            <div className={`row ${style.avatarrow}`}>
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />

                                            </div>
                                            <div className={`row ${style.avatarrow}`}>
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />
                                                <Avatar alt="Contibutors" src={`${profileImagePath}`} />

                                            </div>

                                        </div>
                                    :
                                    <CircularProgress />

                            }

                        </div>





                    </div>

                    <a className={`carousel-control-prev`} href="#demo" role="button" data-slide="prev">
                        <ArrowBackIosOutlinedIcon className={style.Arrow} />
                    </a>
                    <a className={`carousel-control-next`} href="#demo" data-slide="next">
                        <ArrowForwardIosOutlinedIcon className={style.Arrow} />
                    </a>
                </div> */}

        <div
          className={`${style.ShareUpdate} ${
            pageType === "homePage" ? style.homePageRightSideBar : ""
          }`}
          style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          onClick={() => onUpdate("UPDATE")}
        >
          <h5 className={`h17 bold dark-gray`}>Share UPDATE</h5>

          {/* <a className={style.shareupdatelink}>
            <ArrowRightAltOutlinedIcon />
          </a> */}
          <img
            src={arrowSvg}
            className={style.shareupdatelink}
            alt="arrow"
            width="50"
            height="54"
          />
        </div>

        <UpdateTagPostDataModal
          show={showModal}
          onHide={hideUpdateModal}
          modalShow={showModal}
          setModalShow={hideUpdateModal}
          isModalType={modalType}
          // filterType={filterType}
          filterPosts={filterPosts}
          changeValue={changeValue}
          fetchFeedData={fetchFeedData}
          showInviteModalOnPrivateTagPost={showInviteModalOnPrivateTagPost}
          fetchContributors={fetchContributors}
          pageType={pageType}
          onActionSuccess={onActionSuccess}
        />

        {showInviteModal && (
          <InviteFollowers
            key={messageId}
            show={showInviteModal}
            onHide={() => onHideInviteModal()}
            tenantid={tenantId}
            msgid={messageId}
            backdrop="static"
            keyboard={false}
            hideCloseButton={true}
          />
        )}

        <div
          className={`${style.CreateTag} ${
            pageType === "homePage" ? style.homePageRightSideBar : ""
          }`}
          style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          onClick={() => onUpdate("TAG")}
        >
          <h5 className={`h17 bold dark-gray`}>Create TAG</h5>
          {/* <a to="/" className={style.shareupdatelink}>
            <ArrowRightAltOutlinedIcon />
          </a> */}
          <img
            className={style.shareupdatelink}
            src={arrowSvg}
            alt="arrow"
            width="50"
            height="54"
          />
        </div>
        <div
          // className={style.Trending}
          className={`${style.Trending} ${
            pageType === "homePage" ? style.homePageRightSideBar : ""
          }`}
        >
          <h5 className={`h17 bold dark-gray`}>See what is trending</h5>
          <div className={style.tagSection}>
            <h6>TAGs</h6>
            {trendingTags && Object.keys(trendingTags).length !== 0 ? (
              <div>
                {trendingTags.map((trendinglist, i) => (
                  <div
                    className={style.trendingTagNameContainer}
                    style={{
                      pointerEvents: isActionDisabled ? "none" : "auto",
                    }}
                  >
                    <p
                      onClick={() => TagDetail(trendinglist.id)}
                      key={trendinglist.id}
                      className={
                        trendinglist.id === selectedTagId && showData !== "feed"
                          ? style.tagNameClicked
                          : style.tagName
                      }
                    >
                      {" "}
                      {trendinglist.hash_tag_name}{" "}
                    </p>
                    {trendinglist.Keyword_ID === "X" && (
                      <div className={style.trendingTagPrivateStatus}>P</div>
                    )}
                  </div>
                ))}
                <a
                  href="#tags"
                  className={style.Seemore}
                  onClick={(e) => {
                    e.preventDefault();
                    moreTrendingTags();
                  }}
                >
                  See All{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6.093"
                    height="9.64"
                    viewBox="0 0 6.093 9.64"
                  >
                    <g
                      id="Group_2347"
                      data-name="Group 2347"
                      transform="translate(1.273 8.367) rotate(-90)"
                    >
                      <line
                        id="Line_43"
                        data-name="Line 43"
                        x2="3.547"
                        y2="3.547"
                        fill="none"
                        stroke="#373334"
                        strokeLinecap="round"
                        strokeWidth="1.8"
                      />
                      <line
                        id="Line_44"
                        data-name="Line 44"
                        x1="3.547"
                        y2="3.547"
                        transform="translate(3.547)"
                        fill="none"
                        stroke="#373334"
                        strokeLinecap="round"
                        strokeWidth="1.8"
                      />
                    </g>
                  </svg>
                </a>
              </div>
            ) : (
              <p className={style.message}>No Tags are Trending</p>
            )}
          </div>

          <div className={style.asksection}>
            <h6>ASKs</h6>
            {trendingAsks && Object.keys(trendingAsks).length !== 0 ? (
              trendingAsks?.map((trendinglist) => (
                <ul
                  className={style.asks}
                  key={`trendingask-key-${trendinglist?.id}`}
                  onClick={moreTrendingAsks}
                >
                  <li>
                    <AvatarBadge
                      variant="square"
                      src={
                        trendinglist?.uimage
                          ? `${profileImagePath}${trendinglist.uimage}`
                          : process.env.REACT_APP_DUMMY_PROFILE_IMAGE // fallback: env dummy avatar
                      }
                      className={style.askavatar}
                      isPrimaryModerator={
                        String(trendinglist?.mainuserdata?.isPM) === "1"
                      }
                      isModerator={
                        String(trendinglist?.mainuserdata?.isModerator) === "1" &&
                        String(trendinglist?.mainuserdata?.isPM) !== "1"
                      }
                      size={45}
                    />
                    <div className={style.askprofilecontnet}>
                      <p className={style.askprofilecontnetName}>
                        {trendinglist.displayName}
                      </p>
                      <p className={style.askprofilecontnetMessage}>
                        {trendinglist.Message}
                      </p>
                    </div>
                  </li>
                </ul>
              ))
            ) : (
              <p>No Data</p>
            )}
            <a
              href="#asks"
              className={style.Seemore}
              onClick={(e) => {
                e.preventDefault();
                moreTrendingAsks();
              }}
            >
              See All{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6.093"
                height="9.64"
                viewBox="0 0 6.093 9.64"
              >
                <g
                  id="Group_2347"
                  data-name="Group 2347"
                  transform="translate(1.273 8.367) rotate(-90)"
                >
                  <line
                    id="Line_43"
                    data-name="Line 43"
                    x2="3.547"
                    y2="3.547"
                    fill="none"
                    stroke="#373334"
                    strokeLinecap="round"
                    strokeWidth="1.8"
                  />
                  <line
                    id="Line_44"
                    data-name="Line 44"
                    x1="3.547"
                    y2="3.547"
                    transform="translate(3.547)"
                    fill="none"
                    stroke="#373334"
                    strokeLinecap="round"
                    strokeWidth="1.8"
                  />
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default RightSideBar;
